import {
    Box,
    Button, CircularProgress,
    Container, Dialog, DialogContent, DialogTitle,
    FormControl,
    FormHelperText,
    FormLabel,
    Grid, IconButton,
    TextField,
    Typography
} from "@mui/material";
import {useParams} from "react-router-dom";
import {green, greenButtonContained} from "../../Utils/style";
import {useEffect, useState} from "react";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {
    checkAPICallLimit,
    convertMovingItemsToPackageData,
    generateCarShippingQuoteRequest, getInvalidKeysFromObject,
    getMissingKeysFromObject, isValidatePhone, isValidTariffCode, LoadingComponent, SHIPMENT_TYPE_GROUP_ID_CROSS_BORDER,
    SHIPMENT_TYPE_GROUP_ID_FTL,
    SHIPMENT_TYPE_GROUP_ID_LTL, SHIPMENT_TYPE_GROUP_ID_MOVING_CAR,
    SHIPMENT_TYPE_GROUP_ID_MOVING_ITEM, SHIPMENT_TYPE_GROUP_ID_PACKAGE
} from "../../Utils/Helper";
import {WordPressQuoteRating} from "./WordPressQuoteRating";
import {WordPressQuoteLocation} from "./WordPressQuoteLocation";
import {WordPressQuoteShippingDetails} from "./WordPressQuoteShippingDetails";
import {WordPressQuoteContact} from "./WordPressQuoteContact";
import dayjs from "dayjs";
import Link from "@mui/material/Link";
import {FlexBox} from "../Theme/CustomComponent";
import CloseIcon from "@mui/icons-material/Close";

export const WordPressQuote = () => {

    const {tab} = useParams();
    const {lng} = useParams();

    const [movingFrom, setMovingFrom] = useState(null);
    const [movingTo, setMovingTo] = useState(null);
    const [shippingDetails, setShippingDetails] = useState(null);
    const [contact, setContact] = useState(null);
    const [validatedResult, setValidatedResult] = useState(null);
    const [validatedEmail, setValidatedEmail] = useState(null);
    const [isCall, setIsCall] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [apiCheck, setAPICheck] = useState(null);
    const [APIRate, setAPIRate] = useState(null);
    const [AIRate, setAIRate] = useState(null);
    const [carRateFromAI, setCarRateFromAI] = useState(null);
    const [carRate, setCarRate] = useState(null);
    const [movingRate, setMovingRate] = useState(null);
    const [LTLRate, setLTLRate] = useState(null);
    const [LTLRateFromAI, setLTLRateFromAI] = useState(null);
    const [FTLRate, setFTLRate] = useState(null);
    const [FTLRateFromAI, setFTLRateFromAI] = useState(null);
    const [packageRate, setPackageRate] = useState(null);
    const [packageLoading, setPackageLoading] = useState(false);
    const [packageError, setPackageError] = useState(false);
    const [isAbleGetPackageRate, setIsAbleGetPackageRate] = useState(false);
    const [brokerageRate, setBrokerageRate] = useState(null);
    const [HSCodeError, setHSCodeError] = useState(null);
    const [expectedMovingDate, setExpectedMovingDate] = useState('Within 2 weeks');
    const [skidList, setSkidList] = useState(null);
    const [movingSkid, setMovingSkid] = useState(false);
    const [residenceDetails, setResidenceDetails] = useState(null);
    const [movingType, setMovingType] = useState(1);

    console.log('[WordPressQuote] movingType', movingType);
    console.log('[WordPressQuote] residenceDetails', residenceDetails);
    console.log('[WordPressQuote] skidList', skidList);
    console.log('[WordPressQuote] shippingDetails', shippingDetails);


    // console.log('[WordPressQuote] movingSkid', movingSkid);


    const cbHandleMovingDate = (data) => {
        setExpectedMovingDate(data);
    }

    const cbHandleMovingFrom = (data) => {
        setMovingFrom(data);
    }

    const cbHandleMovingTo = (data) => {
        setMovingTo(data);
    }

    const cbHandleShippingDetails = (data) => {
        setShippingDetails(data);
    }

    const cbHandleContact = (data) => {
        setContact(data);
    }

    const cbHandleValidatedEmail = (data) => {
        setValidatedEmail(data);
    }

    const cbHandleMovingSkid = (data) => {
        setMovingSkid(data);
    }

    const cbHandleMovingType = (data) => {
        setMovingType(data);
    }

    const cbHandleSkidList = (data) => {
        setSkidList(data);
    }

    const cbHandleResidenceDetails = (data) => {
        setResidenceDetails(data);
    }

    const handleGetBrokerageRating = async () => {
        try {
            setIsCall(true);
            setLoading(true);
            let requestURL = `${NODE_ROUTE_URI}/brokerage/package/landedCostByServiceName`;

            const itemObject = {
                description: shippingDetails?.description,
                quantity: shippingDetails?.quantity,
                priceEach: shippingDetails?.priceEach,
                currency: shippingDetails?.currency,
                originCountryCode: shippingDetails?.originCountryCode,
                UOM: shippingDetails?.UOM,
                hscode: shippingDetails?.hscode,
                desc_en: shippingDetails?.desc_en,
                desc_cn_gb: shippingDetails?.desc_cn_gb
            }

            let updateShipmentItems = [];
            updateShipmentItems.push(itemObject);

            const data = {
                serviceName: "ups",
                exportCountryCode: movingFrom?.country,
                importCountryCode: movingTo?.country,
                importProvince: movingTo?.province,
                transModes: "INT_TRUCK",
                shipmentType: "COMMERCIAL",
                shipmentItems: updateShipmentItems,
                displayDutyTax: true,
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            });

            if (result?.data?.error) {
                setHSCodeError(result?.data?.error);
                setIsCall(false);
            } else {
                setAPIRate(result?.data);
                setBrokerageRate(result?.data);
            }
        } catch (e) {
            console.log('error', e?.response);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetPackageRatingFromMovingItems = async (packageObject, deepSeekData, movingRating) => {
        try {
            setPackageLoading(true);
            let requestURL = `${PARTNER_URI}/loose-item/3rd-party/partner/rates/landing/all`;

            const updatedFurnitureList = deepSeekData?.items?.map(item => ({
                ...item,
                lengthUnit: "in",
                weightUnit: "lb",
                packageSpecialServices: {
                    wrappingService: false,
                    packingService: false,
                    assemblyService: false,
                    disassemblyService: false
                }
            }))

            const additionalService = {
                scheduleDelivery: false,
                whiteGlove: false,
                packingService: false,
                wrappingService: false,
                assemblyService: false,
                disassemblyService: false,
                storageService: {
                    cubicMeterSpace: 0,
                    storageDays: 0
                }
            }

            const specialServices = Object.keys(additionalService)
                .filter(key => typeof additionalService[key] === 'boolean' && additionalService[key])
                .map(serviceName => ({serviceName}));

            let updatedPackageList = [];
            updatedPackageList.push(packageObject);

            const data = {
                rateData: {
                    shipFromAddress: "",
                    shipFromAddressTwo: "",
                    shipFromSubCity: movingFrom?.subCity,
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromPostalCode: movingFrom?.postalCode,
                    shipFromCountry: movingFrom?.country,
                    shipFromName: "",
                    shipFromPhone: "",
                    shipToAddress: "",
                    shipToAddressTwo: "",
                    shipToSubCity: movingTo?.subCity,
                    shipToCity: movingTo?.city,
                    shipToPostalCode: movingTo?.postalCode,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingTo?.country,
                    shipToName: "",
                    shipToPhone: "",
                    packageData: updatedPackageList,
                },
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone,
                movingReq: {
                    items: updatedFurnitureList,
                    boxList: null,
                    pickupWarehouseId: movingFrom?.warehouse?.id || null,
                    selfDropOff: movingFrom?.option === 'self',
                    pickupAddress: null,
                    pickupSubCity: movingFrom?.subCity,
                    pickupCity: movingFrom?.city,
                    pickupProvince: movingFrom?.province,
                    pickupCountry: movingFrom?.country,
                    pickupPostalCode: movingFrom?.postalCode,
                    deliverWarehouseId: movingTo?.warehouse?.id || null,
                    selfPickup: movingTo?.option === 'self',
                    deliverAddress: null,
                    deliverSubCity: movingTo?.subCity,
                    deliverCity: movingTo?.city,
                    deliverProvince: movingTo?.province,
                    deliverCountry: movingTo?.country,
                    deliverPostalCode: movingTo?.postalCode,
                    specialServices: specialServices,
                    pickupHouseFeatures: {
                        houseType: movingFrom?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingFrom?.propertyType?.houseType,
                        floorLevel: movingFrom?.floorLevel,
                        staircaseNumber: "0",
                        isNarrowStreet: movingFrom?.isNarrowStreet,
                        drivewaySteepLevel: movingFrom?.isSteepDriveway ? 1 : 0,
                        hasLift: !!movingFrom?.lift
                    },
                    deliverHouseFeatures: {
                        houseType: movingTo?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingTo?.propertyType?.houseType,
                        floorLevel: movingTo?.floorLevel,
                        staircaseNumber: "0",
                        isNarrowStreet: movingTo?.isNarrowStreet,
                        drivewaySteepLevel: movingTo?.isSteepDriveway ? 1 : 0,
                        hasLift: !!movingTo?.lift
                    },
                    loadingTime: deepSeekData?.loadingTime,
                    unloadingTime: deepSeekData?.unloadingTime,
                    loadingCost: deepSeekData?.loadingCost,
                    unloadingCost: deepSeekData?.unloadingCost,
                    palletQuantity: +deepSeekData?.pallets,
                    expectedMovingDate: expectedMovingDate
                },
                movingRes: movingRating,
                shipmentTypeGroupId: 8
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })
            setPackageRate(result?.data);
        } catch (e) {
            setPackageError(true);
        } finally {
            setPackageLoading(false);
        }
    }

    const handleGetPackageRating = async () => {
        try {
            setIsCall(true);
            setLoading(true);
            let requestURL = `${PARTNER_URI}/loose-item/3rd-party/partner/rates/landing/all`;

            const packageObject = {
                length: shippingDetails?.length,
                height: shippingDetails?.height,
                width: shippingDetails?.width,
                quantity: shippingDetails?.quantity,
                weight: shippingDetails?.weight,
                lengthUnit: shippingDetails?.lengthUnit,
                weightUnit: shippingDetails?.weightUnit,
            }

            let updatedPackageList = [];
            updatedPackageList.push(packageObject);

            const data = {
                rateData: {
                    shipFromAddress: "",
                    shipFromAddressTwo: "",
                    shipFromSubCity: movingFrom?.subCity,
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromPostalCode: movingFrom?.postalCode,
                    shipFromCountry: movingFrom?.country,
                    shipFromName: "",
                    shipFromPhone: "",
                    shipToAddress: "",
                    shipToAddressTwo: "",
                    shipToSubCity: movingTo?.subCity,
                    shipToCity: movingTo?.city,
                    shipToPostalCode: movingTo?.postalCode,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingTo?.country,
                    shipToName: "",
                    shipToPhone: "",
                    packageData: updatedPackageList,
                },
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            setAPIRate(result?.data);
            setPackageRate(result?.data);

        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const getLTLQuoteByDeepSeek = async () => {
        try {
            setLoading(true);
            let requestURL = `${PARTNER_URI}/shippingLTL/getLTLQuoteByDeepSeek`;
            const palletObject = {
                length: shippingDetails?.length,
                height: shippingDetails?.height,
                width: shippingDetails?.width,
                quantity: shippingDetails?.quantity,
                weight: shippingDetails?.weight,
                lengthUnit: shippingDetails?.lengthUnit,
                weightUnit: shippingDetails?.weightUnit,
            }

            let updatedPalletList = [];
            updatedPalletList.push(palletObject);

            const data = {
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                transitMode: [
                    "rail",
                    "road",
                    "Intermodal"
                ],
                accountBase: "Vitran",
                packageData: updatedPalletList,
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone,
                systemRole: "LTL_RATING"
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[getLTLQuoteByDeepSeek] result', result);

            // setAIRate(result?.data?.ltlQuote);
            // setLTLRateFromAI(result?.data?.ltlQuote);

        } catch (e) {
            console.log('error', e?.response);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetLTLRating = async () => {
        try {
            setIsCall(true);
            setLoading(true);
            let requestURL = `${PARTNER_URI}/shippingLTL/LTLShippingRatingForLanding`;

            const palletObject = {
                length: shippingDetails?.length,
                height: shippingDetails?.height,
                width: shippingDetails?.width,
                quantity: shippingDetails?.quantity,
                weight: shippingDetails?.weight,
                description: "",
                lengthUnit: shippingDetails?.lengthUnit,
                weightUnit: shippingDetails?.weightUnit,
                hscode: "",
                originCountryCode: "",
                currency: "",
                priceEach: "",
                UOM: ""
            }

            let updatedPalletList = [];
            updatedPalletList.push(palletObject);

            const data = {
                shipperAddress: "",
                shipperAddressType: "warehouse",
                shipperSubCity: movingFrom?.subCity,
                shipperCity: movingFrom?.city,
                shipperProvince: movingFrom?.province,
                shipperPostalCode: movingFrom?.postalCode,
                shipperCountry: movingFrom?.country,
                consigneeAddress: "",
                consigneeAddressType: "warehouse",
                consigneeSubCity: movingTo?.subCity,
                consigneeCity: movingTo?.city,
                consigneeProvince: movingTo?.province,
                consigneePostalCode: movingTo?.postalCode,
                consigneeCountry: movingTo?.country,
                packageData: updatedPalletList,
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[handleGetLTLRating] result', result);

            if (result?.data?.length > 0) {
                setLoading(false);
                setAPIRate(result?.data);
                setLTLRate(result?.data);
            } else {
                await getLTLQuoteByDeepSeek();
            }
        } catch (e) {
            console.log(e.response);
            await getLTLQuoteByDeepSeek();
        }
    }

    const getFTLQuoteByDeepSeek = async () => {
        try {
            setLoading(true);
            let requestURL = `${PARTNER_URI}/shippingLTL/getFTLRatingByDeepSeek`;

            const data = {
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                transitMode: [
                    "rail",
                    "road",
                    "Intermodal"
                ],
                accountBase: "Vitran",
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone,
                ftlCount: shippingDetails?.quantity,
                transitCargoType: shippingDetails?.transitCargoType === 'Bonded' ? shippingDetails?.transitCargoType : "",
                totalWeight: shippingDetails?.totalWeight,
                equipment: shippingDetails?.equipment,
                systemRole: "FTL_RATING"
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[getLTLQuoteByDeepSeek] result', result);

            setAIRate(result?.data?.ftlQuote);
            setFTLRateFromAI(result?.data?.ftlQuote);

        } catch (e) {
            console.log('error', e?.response);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetFTLRating = async () => {
        try {
            setIsCall(true);
            setLoading(true);
            let requestURL = `${PARTNER_URI}/shippingLTL/LTLShippingRatingForLanding`;

            const data = {
                shipperAddress: "",
                shipperAddressType: "warehouse",
                shipperSubCity: movingFrom?.subCity,
                shipperCity: movingFrom?.city,
                shipperProvince: movingFrom?.province,
                shipperPostalCode: movingFrom?.postalCode,
                shipperCountry: movingFrom?.country,
                consigneeAddress: "",
                consigneeAddressType: "warehouse",
                consigneeSubCity: movingTo?.subCity,
                consigneeCity: movingTo?.city,
                consigneeProvince: movingTo?.province,
                consigneePostalCode: movingTo?.postalCode,
                consigneeCountry: movingTo?.country,
                packageData: [],
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone,
                ftlCount: shippingDetails?.quantity,
                transitCargoType: shippingDetails?.transitCargoType === 'Bonded' ? shippingDetails?.transitCargoType : "",
                totalWeight: shippingDetails?.totalWeight,
                equipment: shippingDetails?.equipment,
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[handleGetFTLRating] result', result);

            if (result?.data?.length > 0) {
                setLoading(false);
                setAPIRate(result?.data);
                setFTLRate(result?.data);
            } else {
                await getFTLQuoteByDeepSeek();
            }

        } catch (e) {
            console.log(e.response);
            await getFTLQuoteByDeepSeek();
        }
    }

    const handleConvertToItemList = async () => {
        try {
            setIsCall(true);
            setLoading(true);
            let requestURL = `${NODE_ROUTE_URI}/deepSeek/admin/getMovingInformationByDeepSeek`;

            const messages = [];
            messages.push(shippingDetails)

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: {
                    systemRole: "MOVING",
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province?.code,
                    shipFromPostalCode: movingFrom?.postalCode,
                    shipFromCountry: movingFrom?.country,
                    shipFromHouseType: movingFrom?.propertyType?.houseType,
                    shipFromHasLift: movingFrom?.lift !== 0,
                    shipFromFloorLevel: movingFrom?.floorLevel,
                    shipToCity: movingTo?.city,
                    shipToProvince: movingTo?.province?.code,
                    shipToPostalCode: movingTo?.postalCode,
                    shipToCountry: movingTo?.country,
                    shipToHouseType: movingTo?.propertyType?.houseType,
                    shipToHasLift: movingTo?.lift !== 0,
                    shipToFloorLevel: movingTo?.floorLevel,
                    items: shippingDetails?.content,
                    workers: "2",
                    messages: messages,
                }
            })

            // console.log('[handleConvertToItemList] result', result);

            const itemList = result?.data?.items;

            console.log('[handleConvertToItemList] item list', itemList);

            if (itemList?.length === 0) {
                setError(true);
            } else {
                const convertToPackageResult = convertMovingItemsToPackageData(itemList);
                console.log('[handleConvertToItemList] convertToPackageResult', convertToPackageResult);
                const enableToGetPackageRating = convertToPackageResult?.isValid;

                setIsAbleGetPackageRate(convertToPackageResult?.isValid);
                const movingRating = await handleGetMovingRating(result?.data, !enableToGetPackageRating);

                if (enableToGetPackageRating) {
                    await handleGetPackageRatingFromMovingItems(convertToPackageResult?.packageData, result?.data, movingRating);
                }
            }

        } catch (e) {
            setError(true);
        }
    }

    const handleGetMovingRating = async () => {
        setLoading(true);
        let requestURL = `${NODE_ROUTE_URI}/movingService/movingItemGetGeneralRatingFromAIWithChatCompletion`;

        let movingContent = "";

        if (shippingDetails?.role) {
            movingContent = shippingDetails?.content
        } else if (movingType === 2) {
            movingContent = `${skidList?.quantity} ${skidList?.description} (${skidList?.length}x${skidList?.width}x${skidList?.height} in), unit weight: ${skidList?.weight} lb`;
        } else if (movingType === 4) {
            movingContent = `${shippingDetails?.quantity} ${shippingDetails?.boxSize?.name} (${shippingDetails?.length}x${shippingDetails?.width}x${shippingDetails?.height} ${shippingDetails?.lengthUnit}), unit weight: ${shippingDetails?.weight} ${shippingDetails?.weightUnit}`;
        } else if (movingType === 1) {
            movingContent = `${residenceDetails?.numberOfBedRooms} bedroom(s), ${residenceDetails?.numberOfLivingRooms} living room(s)`
        }

        const data = {
            content: movingContent,
            selfDropOff: movingFrom?.option === 'self',
            pickupAddress: null,
            pickupSubCity: movingFrom?.subCity,
            pickupCity: movingFrom?.city,
            pickupProvince: movingFrom?.province,
            pickupCountry: movingFrom?.country,
            pickupPostalCode: movingFrom?.postalCode,
            pickupLatitude: movingFrom?.latitude,
            pickupLongitude: movingFrom?.longitude,
            deliverWarehouseId: movingTo?.warehouse?.id || null,
            selfPickup: movingTo?.option === 'self',
            deliverAddress: null,
            deliverSubCity: movingTo?.subCity,
            deliverCity: movingTo?.city,
            deliverProvince: movingTo?.province,
            deliverCountry: movingTo?.country,
            deliverPostalCode: movingTo?.postalCode,
            deliverLatitude: movingTo?.latitude,
            deliverLongitude: movingTo?.longitude,
            pickupHouseFeatures: {
                houseType: movingFrom?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingFrom?.propertyType?.houseType,
                floorLevel: movingFrom?.floorLevel,
                staircaseNumber: "0",
                isNarrowStreet: movingFrom?.isNarrowStreet,
                drivewaySteepLevel: movingFrom?.isSteepDriveway ? 1 : 0,
                hasLift: !!movingFrom?.lift
            },
            deliverHouseFeatures: {
                houseType: movingTo?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingTo?.propertyType?.houseType,
                floorLevel: movingTo?.floorLevel,
                staircaseNumber: "0",
                isNarrowStreet: movingTo?.isNarrowStreet,
                drivewaySteepLevel: movingTo?.isSteepDriveway ? 1 : 0,
                hasLift: !!movingTo?.lift
            },
            userEmail: contact?.email,
            userPhone: contact?.phone,
            labourNumber: 2,
            expectedMovingDate: expectedMovingDate,
            skidList: movingType === 2 ? [skidList] : [],
            roomResidence: movingType === 1 ? residenceDetails : null
        }

        try {
            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[handleGetMovingRating] result', result);
            setAPIRate(result?.data);
            setMovingRate(result?.data);

            if (movingType !== 1 && movingType !== 2) {
                const convertToPackageResult = convertMovingItemsToPackageData(result?.data?.itemsFromAI?.items);

                setIsAbleGetPackageRate(result?.data?.needToCallPackageRating);

                if (result?.data?.needToCallPackageRating) {
                    await handleGetPackageRatingFromMovingItems(convertToPackageResult?.packageData, result?.data?.itemsFromAI, result?.data);
                }
            }

        } catch (e) {
            console.log(e.response);
            setError(true);

        } finally {
            setLoading(false);
        }
    }

    const getCarQuoteByDeepSeek = async () => {
        try {
            setLoading(true);
            setIsCall(true);
            let requestURL = `${NODE_ROUTE_URI}/deepseek/admin/getCarQuoteByDeepSeek`;

            const carObject = {
                make: shippingDetails.make,
                model: shippingDetails.model,
                yearOfProduction: shippingDetails.year,
                categoryValue: "",
                quantity: 1
            }

            let updatedCarList = [];
            updatedCarList.push(carObject);

            const content = generateCarShippingQuoteRequest({
                shipFromAddress: "",
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToAddress: "",
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                packageData: updatedCarList,
            })

            const data = {
                messages: [
                    {
                        role: "user",
                        content: content
                    }
                ],
                systemRole: "CAR_QUOTE",
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                packageData: updatedCarList,
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[getCarQuoteByDeepSeek] result', result);
            setAIRate(result?.data);
            setCarRateFromAI(result?.data);
        } catch (e) {
            console.log('error', e?.response);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetVehicleRating = async () => {
        try {
            setLoading(true);

            let requestURL = `${NODE_ROUTE_URI}/movingCar/getMovingCarRatingList`;

            const carObject = {
                make: shippingDetails.make,
                model: shippingDetails.model,
                yearOfProduction: shippingDetails.year,
                categoryValue: "",
                quantity: 1
            }

            let updatedCarList = [];
            updatedCarList.push(carObject);

            const data = {
                shipFromAddress: "",
                shipFromSubCity: movingFrom?.subCity,
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToAddress: "",
                shipToSubCity: movingTo?.subCity,
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                packageData: updatedCarList,
                sendNotifyEmail: true,
                userEmail: contact?.email,
                userPhone: contact?.phone
            }

            // console.log('[handleGetVehicleRating] data', data);

            const result = await axios({
                method: 'post',
                url: requestURL,
                // headers: {Authorization: `Bearer ${storedToken}`},
                data: data
            })

            console.log('[handleGetVehicleRating] rating result', result);
            // setErrorMessage('');

            // if (+result?.data?.finalTotal > 0) {
            //     setLoading(false);
            setAPIRate(result?.data);
            setCarRate(result?.data);
            // } else {
            //     await getCarQuoteByDeepSeek();
            // }
        } catch (e) {
            // console.log(e.response);
            // await getCarQuoteByDeepSeek();
        } finally {
            setLoading(false);
        }
    }

    const validateEmailAddress = async (email) => {
        let requestURL = `${NODE_ROUTE_URI}/validateEmail`;
        try {
            const result = await axios({
                method: 'post',
                url: requestURL,
                data: {
                    email: email,
                    validateRegex: true,
                    validateMx: true,
                    validateTypo: false,
                    validateDisposable: false,
                    validateSMTP: false
                }
            })
            console.log('[validateEmailAddress] result - ', result);
            return result?.data;
        } catch (e) {
            console.log(e.response)
        }
    }

    const validationShippingDetails = (shippingDetails) => {
        switch (tab.toLowerCase()) {
            case 'car':
                const carValidation = getMissingKeysFromObject({...shippingDetails});
                return carValidation?.length === 0;
            case 'moving':
                const movingValidation = getMissingKeysFromObject({...shippingDetails});
                if (shippingDetails?.role) {
                    return movingValidation?.length === 0
                }
                const boxAndSkidInvalid = getInvalidKeysFromObject({
                    length: shippingDetails?.length,
                    width: shippingDetails?.width,
                    height: shippingDetails?.height,
                    weight: shippingDetails?.weight,
                    quantity: shippingDetails?.quantity
                });
                return (movingValidation?.length === 0 && boxAndSkidInvalid?.length === 0);
            case 'ltl':
                const palletMissing = getMissingKeysFromObject({...shippingDetails});
                const palletInvalid = getInvalidKeysFromObject({
                    length: shippingDetails?.length,
                    width: shippingDetails?.width,
                    height: shippingDetails?.height,
                    weight: shippingDetails?.weight,
                    quantity: shippingDetails?.quantity
                });
                return (palletMissing?.length === 0 && palletInvalid?.length === 0);
            case 'package':
                const packageMissing = getMissingKeysFromObject({...shippingDetails});
                const packageInvalid = getInvalidKeysFromObject({
                    length: shippingDetails?.length,
                    width: shippingDetails?.width,
                    height: shippingDetails?.height,
                    weight: shippingDetails?.weight,
                    quantity: shippingDetails?.quantity
                });
                return (packageMissing?.length === 0 && packageInvalid?.length === 0);
            case 'brokerage':
                const customsItemMissing = getMissingKeysFromObject({
                    quantity: shippingDetails?.quantity,
                    priceEach: shippingDetails?.priceEach,
                    currency: shippingDetails?.currency,
                    originCountryCode: shippingDetails?.originCountryCode,
                    hscode: shippingDetails?.hscode
                });
                const customsItemInvalid = getInvalidKeysFromObject({
                    quantity: shippingDetails?.quantity,
                    priceEach: shippingDetails?.priceEach
                })

                const totalValue = +shippingDetails?.quantity * +shippingDetails?.priceEach;

                const hscodeValid = isValidTariffCode(shippingDetails?.hscode);

                // console.log('[validationShippingDetails] - brokerage -  customsItemMissing', customsItemMissing);
                // console.log('[validationShippingDetails] - brokerage -  customsItemInvalid', customsItemInvalid);
                // console.log('[validationShippingDetails] - brokerage -  total value', totalValue);

                return (customsItemMissing?.length === 0 && customsItemInvalid?.length === 0 && totalValue <= 1000000 && hscodeValid);
            case 'ftl':
                const FTLDetailMissing = getMissingKeysFromObject({
                    quantity: shippingDetails?.quantity,
                });
                const FTLDetailInvalid = getInvalidKeysFromObject({
                    quantity: shippingDetails?.quantity,
                });

                return (FTLDetailMissing?.length === 0 && FTLDetailInvalid?.length === 0);
            default:
                return true
        }
    }

    const validation = async () => {
        const movingFromValidation = getMissingKeysFromObject({
            // city: movingFrom?.city || movingFrom?.subCity,
            // province: movingFrom?.province,
            country: movingFrom?.country,
            postalCode: tab?.toLowerCase() === 'brokerage' ? "N/A" : movingFrom?.postalCode,
            houseType: tab?.toLowerCase() === 'moving' ? movingFrom?.propertyType : "N/A"
        })

        const movingToValidation = getMissingKeysFromObject({
            // city: movingTo?.city || movingTo?.subCity,
            province: (tab?.toLowerCase() === 'brokerage' && (movingTo?.country === 'CA' || movingTo?.country === 'US' || movingTo?.country === 'MX')) ? movingTo?.province : "N/A",
            country: movingTo?.country,
            postalCode: tab?.toLowerCase() === 'brokerage' ? "N/A" : movingTo?.postalCode,
            houseType: tab?.toLowerCase() === 'moving' ? movingTo?.propertyType : "N/A"
        })

        const shippingDetailsValidation = validationShippingDetails(shippingDetails);

        const contactEmailCheck = await validateEmailAddress(contact?.email);
        cbHandleValidatedEmail(contactEmailCheck);

        const contactPhoneCheck = tab?.toLowerCase() === 'moving' ? isValidatePhone(contact?.phone) : true;

        if (movingFromValidation?.length > 0 ||
            movingToValidation.length > 0 ||
            !shippingDetailsValidation ||
            !contactEmailCheck?.valid ||
            !contactPhoneCheck
        ) {
            return false
        } else {
            return true
        }
    }

    const handleGetRatingMap = async () => {
        switch (tab.toLowerCase()) {
            case 'car':
                await handleGetVehicleRating();
                break;
            case 'moving':
                // await handleConvertToItemList();
                await handleGetMovingRating();
                break;
            case 'ltl':
                await handleGetLTLRating();
                break
            case 'package':
                await handleGetPackageRating();
                break
            case 'brokerage':
                await handleGetBrokerageRating();
                break
            case 'ftl':
                await handleGetFTLRating();
                break
            default:
                return true
        }
    }

    const handleGetRating = async () => {
        const validationResult = await validation();
        console.log('[handleGetRating] validationResult', validationResult);
        setValidatedResult(validationResult);
        if (validationResult) {
            const apiCheckResult = checkAPICallLimit('iframe');
            setAPICheck(apiCheckResult);
            console.log('[handleGetRating] api check result', apiCheckResult);
            if (apiCheckResult?.allowed) {
                await handleGetRatingMap();
            }
        }
    }

    const handleRedirectToApp = () => {
        window.top.location.href = 'https://app.uucargo.ca/sign-in';
    }

    const handleRedirectToMoreShippingOption = () => {
        window.top.location.href = 'https://uucargo.ca/instant-shipping-calculator/';
    }

    const handleRefresh = () => {
        window.top.location.reload();
    }


    const handleGetAnotherQuote = () => {
        setAPIRate(null);
        setAIRate(null);
        setError(false);
        setIsCall(false);
        setMovingFrom(null);
        setMovingTo(null);
        setShippingDetails(null);
        setContact(null);
        setValidatedEmail(null);
        setValidatedResult(null);
        setCarRate(null);
        setCarRateFromAI(null);
        setMovingRate(null);
        setLTLRate(null);
        setLTLRateFromAI(null);
        setFTLRate(null);
        setFTLRateFromAI(null);
        setPackageRate(null);
        setPackageLoading(false);
        setPackageError(false);
        setIsAbleGetPackageRate(false);
        setBrokerageRate(null);
        setHSCodeError(null);
        setExpectedMovingDate('Within 2 weeks');
        setSkidList(null);
        setResidenceDetails(null);
        setMovingType(1);
    }

    const redirectToApp = () => {

        return (
            <>
                <Grid size={{xs: 12, md: 12}}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px'
                    }}>
                        <Button
                            variant='contained'
                            sx={greenButtonContained}
                            onClick={handleRedirectToMoreShippingOption}
                        >
                            <Typography sx={{textTransform: 'none'}}>
                                {lng === 'cn' ? '更多运输选项' : "More Shipping Option"}
                            </Typography>
                        </Button>
                        <Button
                            variant='contained'
                            sx={greenButtonContained}
                            onClick={handleGetAnotherQuote}
                        >
                            <Typography sx={{textTransform: 'none'}}>
                                {lng === 'cn' ? '重新询价' : "Get Another Quote"}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
            </>
        )
    }

    const NoRate = () => {
        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '700', color: 'warning.main', fontSize: '1.1rem'}}>
                        {lng === 'cn'
                            ? '抱歉，根据您当前的选择，系统暂时无法自动生成实时报价。'
                            : 'Instant Quote Unavailable based on your current selections.'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography sx={{color: 'text.secondary', lineHeight: 1.6}}>
                        {lng === 'cn'
                            ? '您的请求已成功转交给人工客服团队，请耐心等待。我们将根据当前的物流行情和您的具体需求，进行多渠道资源匹配与比价。'
                            : 'Your request has been successfully forwarded to our support team. Please be patient as we conduct a comprehensive manual assessment and compare multiple shipping channels to meet your specific needs.'}
                    </Typography>
                </Grid>
                <Grid container item spacing={2} size={{xs: 12}} sx={{mt: 1, alignItems: 'center'}}>
                    <Grid size={{xs: 12, sm: 7}}>
                        <Box sx={{pl: 2, borderLeft: '3px solid #eee'}}>
                            <Typography variant="body2" sx={{mb: 1.5}}>
                                <strong>{lng === 'cn' ? '客服热线' : 'Hotline'}:</strong> +1 (604) 998-1888
                            </Typography>
                            <Typography variant="body2" sx={{mb: 1.5}}>
                                <strong>{lng === 'cn' ? '官方邮箱' : 'Email'}:</strong> op@uucargo.ca
                            </Typography>
                            <Typography variant="caption" sx={{color: 'text.disabled', display: 'block', mt: 1}}>
                                {lng === 'cn'
                                    ? '办公时间：周一至周五 9:00 AM - 5:00 PM (PST)'
                                    : 'Office Hours: Mon-Fri 9:00 AM - 5:00 PM (PST)'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid size={{xs: 12, sm: 5}} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Box
                            component="img"
                            src="https://storage.googleapis.com/uucargo-resource/image/icon/UUCargoBarcode.png"
                            alt="UU Cargo WeChat"
                            sx={{
                                width: 120,
                                height: 120,
                                borderRadius: 1,
                                border: '1px solid #f0f0f0',
                                p: 0.5,
                                bgcolor: '#fff',
                                boxShadow: '0px 2px 8px rgba(0,0,0,0.06)'
                            }}
                        />
                        <Typography variant="caption" sx={{mt: 1, color: 'text.primary', fontWeight: '600'}}>
                            {lng === 'cn' ? '微信客服扫码' : 'WeChat Support'}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const RegisterLink = () => {

        const [isEmailExist, setIsEmailExist] = useState(false);
        const [loading, setLoading] = useState(false);
        const [success, setSuccess] = useState(false);
        const [error, setError] = useState(false);
        const [account, setAccount] = useState(null);

        const verifyEmail = async () => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/login_middleware/verifyEmailExist`;

                const result = await axios({
                    method: 'POST',
                    url: requestURL,
                    data: {
                        email: contact?.email,
                    }
                });

                setIsEmailExist(result.data);

                return result.data;
            } catch (e) {
                return null
            }
        }

        const quickSignUp = async () => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/login_middleware/quickSignupFromGuest`;

                const result = await axios({
                    method: 'POST',
                    url: requestURL,
                    data: {
                        email: contact?.email,
                        phone: contact?.phone?.replace(/\D/g, ""),
                        sendActiveEmail: true
                    }
                });

                return result.data;
            } catch (e) {
                return null
            }
        }

        const convertMovingOrder = async ({userId}) => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/movingService/editMovingOrderDetailsFromGuest`;


                let data = {
                    backendOrderId: movingRate?.uucOrderId,
                    userId: userId,
                    ownerRole: 1,
                    orderSubType: "Quote"
                }


                const result = await axios({
                    method: 'PATCH',
                    url: requestURL,
                    data: data
                });

                return result.data;
            } catch (e) {
                return null
            }
        }

        const handleQuickSignUp = async () => {

            try {
                setLoading(true);
                setAccount(null);

                const accountInfo = await quickSignUp();
                setAccount(accountInfo);

                if (accountInfo?.id && movingRate?.uucOrderType?.toLowerCase() === 'moving') {
                    convertMovingOrder({userId: accountInfo?.id});
                }

                setSuccess(true);
                setError(false);

            } catch (e) {

                setSuccess(false);
                setError(true)

            } finally {
                setLoading(false);
            }
        }

        useEffect(() => {
            (async () => {
                await verifyEmail();
            })();
        }, [contact?.email]);

        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        {lng === 'cn' ? '后续步骤：注册并保存' : 'Next Steps: Register & Save '}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography>
                        {lng === 'cn'
                            ? '如需预订此货件并管理您的未来订单，请在我们的平台上创建您的官方账户。只需一分钟即可开始：'
                            : 'To book this shipment and manage your future orders, please create your official account on our platform. It only takes a minute to get started:'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Link href="https://app.uucargo.ca"
                          target="_blank"
                          rel="noopener"
                          underline="hover">
                        <Typography>
                            {lng === 'cn' ? '点击此处注册：app.uucargo.ca' : 'Register Here: app.uucargo.ca'}
                        </Typography>
                    </Link>
                </Grid>
                <Grid size={{xs: 12}}>
                    {
                        loading ?
                            <Box>
                                <CircularProgress/>
                            </Box>
                            :
                            success ?
                                <>
                                    <Typography>
                                        {lng === 'cn' ?
                                            '注册成功！请检查您的邮箱以激活账号。以下是您的临时密码，请在登录后重新设置密码。' :
                                            'Sign-up successful! Please check your email to activate your account. Your temporary password is shown below; please reset it after logging in.'}
                                    </Typography>
                                    <Typography sx={{textAlign: 'center', fontWeight: '600'}}>
                                        {account?.tempPassword}
                                    </Typography>
                                </>
                                :
                                error ?
                                    <Typography>
                                        {lng === 'cn' ? '注册失败。如需完成注册，请点击上方链接。' : 'Sign-up failed. To complete your registration, please click the link above.'}
                                    </Typography>
                                    :
                                    (!isEmailExist) &&
                                    <Button
                                        variant='contained'
                                        onClick={handleQuickSignUp}>
                                        <Typography>
                                            {lng === 'cn' ? '快速注册' : 'Quick Sign Up'}
                                        </Typography>
                                    </Button>
                    }
                </Grid>
            </Grid>
        )
    }

    const Coupon = () => {
        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        {lng === 'cn' ? '特别欢迎礼包' : 'A Special Welcome Gift'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography>
                        {lng === 'cn' ? (
                            <>
                                为了感谢您开启首次货运，我们为您提供服务费用 <span
                                style={{fontWeight: '600'}}>$5</span> 的优惠。请在结账时使用以下优惠码：
                            </>
                        ) : (
                            <>
                                To help you get started with your first shipment, we’d like to offer you a <span
                                style={{fontWeight: '600'}}>$5</span> discount on our
                                services. Please use the coupon code below at checkout:
                            </>
                        )}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        UUCREGFEBX5
                    </Typography>
                </Grid>
            </Grid>
        )
    }

    const Feedback = () => {

        const [loading, setLoading] = useState(false);
        const [hasSubmit, setHasSubmit] = useState(false);
        const [openPopup, setOpenPopup] = useState(false);

        const handleGetShipmentTypeId = () => {
            switch (tab.toLowerCase()) {
                case 'car':
                    return SHIPMENT_TYPE_GROUP_ID_MOVING_CAR;
                case 'moving':
                    return SHIPMENT_TYPE_GROUP_ID_MOVING_ITEM;
                case 'ltl':
                    return SHIPMENT_TYPE_GROUP_ID_LTL;
                case 'package':
                    return SHIPMENT_TYPE_GROUP_ID_PACKAGE;
                case 'brokerage':
                    return SHIPMENT_TYPE_GROUP_ID_CROSS_BORDER;
                case 'ftl':
                    return SHIPMENT_TYPE_GROUP_ID_FTL;
                default:
                    return 0;
            }
        }


        const updateWebQuoteHistoryLikeOrDislike = async ({like = 0, dislike = 0}) => {

            let requestURL = `${NODE_ROUTE_URI}/webQuoteHistory/updateWebQuoteHistoryLikeOrDislike`;
            try {
                setLoading(true);
                setHasSubmit(true);

                let typeId = handleGetShipmentTypeId();

                console.log('[updateWebQuoteHistoryLikeOrDislike] typeId', typeId);

                const data = {
                    userEmail: contact?.email,
                    shipmentTypeGroupId: handleGetShipmentTypeId(),
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromCountry: movingFrom?.country,
                    shipToCity: movingTo?.city,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingFrom?.country,
                    likeIt: like,
                    dislikeIt: dislike
                }

                await axios({
                    method: "POST",
                    url: requestURL,
                    data: data

                })
            } catch (e) {

            } finally {
                setLoading(false);
            }
        }

        useEffect(() => {
            let timer;
            timer = setTimeout(() => {
                setOpenPopup(true);
            }, 15000);

            return () => {
                if (timer) clearTimeout(timer);
            };
        }, []);

        return (
            <>
                <Grid container spacing={2}>
                    <Grid size={{xs: 12}}>
                        <Typography variant='subtitle1' sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '您的体验对我们很重要' : 'Your feedback matters'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Typography variant='body2'>
                            {lng === 'cn' ? '您对这个报价满意吗？' : 'Are you happy with this quote?'}
                        </Typography>
                    </Grid>
                    <FlexBox justifyContent='flex-start'>
                        <Button
                            onClick={() => updateWebQuoteHistoryLikeOrDislike({like: 1})}
                            disabled={hasSubmit}
                            loading={loading}>
                            👍
                        </Button>
                        <Button
                            onClick={() => updateWebQuoteHistoryLikeOrDislike({dislike: 1})}
                            disabled={hasSubmit}
                            loading={loading}>
                            👎
                        </Button>
                    </FlexBox>
                    {
                        hasSubmit &&
                        <Typography variant='caption'>
                            {lng === 'cn' ? '感谢您的反馈' : 'Thank you!'}
                        </Typography>
                    }
                </Grid>
                <Dialog
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                >
                    <DialogTitle sx={{m: 0, p: 2, fontWeight: 700}}>
                        {lng === 'cn' ? '满意我们的报价吗？' : 'Happy with the quote?'}
                        <IconButton
                            onClick={() => setOpenPopup(false)}
                            sx={{position: 'absolute', right: 8, top: 8}}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" sx={{mb: 2}}>
                            {lng === 'cn'
                                ? '只需一秒，告诉我们您的想法！'
                                : 'Takes just a second to let us know!'}
                        </Typography>
                        <FlexBox justifyContent='center' gap={4}>
                            <Button
                                onClick={() => updateWebQuoteHistoryLikeOrDislike({like: 1})}
                                disabled={hasSubmit}
                            >
                                <Typography>👍</Typography>
                            </Button>
                            <Button
                                onClick={() => updateWebQuoteHistoryLikeOrDislike({dislike: 1})}
                                disabled={hasSubmit}
                            >
                                <Typography>👎</Typography>
                            </Button>
                        </FlexBox>
                        {hasSubmit && (
                            <Typography align="center" sx={{mt: 2, color: 'green', fontWeight: 600}}>
                                {lng === 'cn' ? '感谢反馈！' : 'Feedback Received!'}
                            </Typography>
                        )}
                    </DialogContent>
                </Dialog>
            </>
        )
    }


    if (!loading && error) {
        return (
            <Container maxWidth='xl'>
                <Box sx={{
                    display: 'flex',
                    padding: '40px 0px'
                }}>
                    <Box sx={{
                        border: `10px solid ${green}`,
                        borderRadius: '10px',
                        padding: '20px',
                        width: '100%',
                        minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                    }}>
                        <Grid container spacing={4}>
                            <Grid size={{xs: 12}}>
                                <NoRate/>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <Feedback/>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <RegisterLink/>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <Coupon/>
                            </Grid>
                            {redirectToApp()}
                        </Grid>
                    </Box>
                </Box>
            </Container>
        )
    }

    if (APIRate || AIRate) {
        return (
            <Container maxWidth='xl'>
                <Box sx={{
                    display: 'flex',
                    padding: '40px 0px'
                }}>
                    <Box sx={{
                        border: `10px solid ${green}`,
                        borderRadius: '10px',
                        padding: '20px',
                        width: '100%',
                        minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                    }}>
                        <Grid container spacing={4}>
                            <WordPressQuoteRating
                                tab={tab}
                                redirectToApp={redirectToApp}
                                movingFrom={movingFrom}
                                movingTo={movingTo}
                                shippingDetails={shippingDetails}
                                APIRate={APIRate}
                                AIRate={AIRate}
                                carRate={carRate}
                                carRateFromAI={carRateFromAI}
                                movingRate={movingRate}
                                LTLRate={LTLRate}
                                LTLRateFromAI={LTLRateFromAI}
                                FTLRate={FTLRate}
                                FTLRateFromAI={FTLRateFromAI}
                                packageRate={packageRate}
                                packageLoading={packageLoading}
                                packageError={packageError}
                                isAbleGetPackageRate={isAbleGetPackageRate}
                                brokerageRate={brokerageRate}
                                lng={lng}
                                NoRate={NoRate}
                                RegisterLink={RegisterLink}
                                Coupon={Coupon}
                                Feedback={Feedback}/>
                        </Grid>
                    </Box>
                </Box>
            </Container>
        )
    }

    console.log('[WordPressQuote] shipping details', shippingDetails);
    console.log('[WordPressQuote] expected moving date', expectedMovingDate);
    console.log('[WordPressQuote] contact', contact);

    return (
        <Container maxWidth='xl'>
            <Box sx={{
                display: 'flex',
                padding: '40px 0px'
            }}>
                <Box sx={{
                    border: `10px solid ${green}`,
                    borderRadius: '10px',
                    padding: '20px',
                    width: '100%',
                    minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                }}>
                    <Grid container spacing={4}>
                        <WordPressQuoteLocation tab={tab}
                                                cbHandleMovingFrom={cbHandleMovingFrom}
                                                cbHandleMovingTo={cbHandleMovingTo}
                                                validatedResult={validatedResult}
                                                lng={lng}
                                                movingSkid={movingSkid}/>
                        <WordPressQuoteShippingDetails tab={tab}
                                                       cbHandleShippingDetails={cbHandleShippingDetails}
                                                       validatedResult={validatedResult}
                                                       lng={lng}
                                                       movingFrom={movingFrom}
                                                       movingTo={movingTo}
                                                       HSCodeError={HSCodeError}
                                                       validateEmailAddress={validateEmailAddress}
                                                       cbHandleValidatedEmail={cbHandleValidatedEmail}
                                                       contact={contact}
                                                       cbHandleMovingDate={cbHandleMovingDate}
                                                       cbHandleMovingSkid={cbHandleMovingSkid}
                                                       cbHandleSkidList={cbHandleSkidList}
                                                       movingType={movingType}
                                                       cbHandleMovingType={cbHandleMovingType}
                                                       cbHandleResidenceDetails={cbHandleResidenceDetails}/>
                        <WordPressQuoteContact tab={tab}
                                               cbHandleContact={cbHandleContact}
                                               validatedResult={validatedResult}
                                               validatedEmail={validatedEmail}
                                               cbHandleMovingDate={cbHandleMovingDate}
                                               lng={lng}/>
                        <Grid size={{xs: 12}}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                                <Button
                                    variant='contained'
                                    sx={greenButtonContained}
                                    // size='small'
                                    // loading={loading}
                                    onClick={handleGetRating}
                                    disabled={isCall}
                                >
                                    <Typography sx={{textTransform: 'none'}}>
                                        {lng === 'cn' ? '获取免费报价' : "Get Free Quote"}
                                    </Typography>
                                </Button>
                                {
                                    (!apiCheck?.allowed && apiCheck !== null) &&
                                    <FormHelperText sx={{color: 'error.main'}}>
                                        {lng === 'cn' ? `10分钟内仅允许10次免费查询，请于 ${dayjs(apiCheck?.nextAvailable).format('h:mm:ss a')} 后再试。` : `Maximum 10 free quotes per 10 minutes. Try again at ${dayjs(apiCheck?.nextAvailable).format('h:mm:ss a')}.`}
                                    </FormHelperText>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <LoadingComponent loading={loading} message={lng === 'cn' ? "正在加载报价" : "Loading quote..."}/>
        </Container>
    )
}